import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User } from './master-consulta-usuarios.models';
const BASE_PATH = environment.basePath;

interface Client {
  id: string;
  name: string;
}
@Injectable({
  providedIn: 'root',
})
export class MasterConsultaUsuariosService {
  constructor(private _$http: HttpClient) {}

  getUsers() {
    return (
      this._$http
        .get<any>(`${BASE_PATH}/bff/users`)
        // .get<User[]>('http://localhost:4444/api/bff/usersaccess')
        .toPromise()
    );
  }

  getUsersSearch(payload: string) {
    return (
      this._$http
        .post<User[]>(`${BASE_PATH}/bff/users/findByName`, payload)
        //.get<User[]>('http://localhost:4444/api/bff/usersaccess/search')
        .toPromise()
    );
  }

  checkIfExistClientsToAssociate(): Promise<Client[]> {
    return this._$http
      .get<Client[]>(`${BASE_PATH}/bff/master/users/create/clients/list`)
      .toPromise();
  }
}
